import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Order as SchemaOrder } from '../schemas/Order';
import { type UpdateVariantInfoRequestBody as SchemaUpdateVariantInfoRequestBody } from '../schemas/UpdateVariantInfoRequestBody';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const UpdateVariantInfoContentType = 'application/json' as const;
export type UpdateVariantInfoRequest = SchemaUpdateVariantInfoRequestBody;
export type UpdateVariantInfoResponses = LinkCommonErrorResponses & {
    /**
     * @description Variants info updated
     */
    '200': {
        'application/json': SchemaOrder;
    };
};
export type UpdateVariantInfoResponseSuccess = UpdateVariantInfoResponses['200']['application/json'];
export type UpdateVariantInfoSearchParams = {
    signature: string;
};
export type UpdateVariantInfoPathParameters = {
    store_slug: string;
    order_id: string;
};
export const UpdateVariantInfoUrl = '/{store_slug}/variants_info/{order_id}' as const;
export const UpdateVariantInfoMethod = 'PATCH' as const;
export const getUpdateVariantInfoUrl = (params: UpdateVariantInfoPathParameters) =>
    UpdateVariantInfoUrl.replace(/\{(\w+)\}/g, (_match, param: keyof UpdateVariantInfoPathParameters) =>
        String(params[param])
    );
